import Layout from "../layout";
import CategorySection from "./components/CategorySection";
import HeroBanner from "./components/HeroBanner";

export default function Home() {
	return (
		<Layout>
			<div className="p-4 sm:p-8 border rounded-large bg-gradient-main">
				<HeroBanner />
				<CategorySection />
			</div>
		</Layout>
	);
}
